export class Option {
	text: string;
	value: string;

	constructor(text: string, value: string) {
		this.text = text;
		this.value = value;
	}
}
